import { NameScammed } from "./NameScammed";
import { useTranslation } from "react-i18next";

export const Estafados = ({ scammedUsers }) => {
  const { t } = useTranslation();

  return (
    scammedUsers.length > 0 &&
    <div className="p-6 bg-gradient-to-r from-orange-50 to-orange-100 shadow-lg rounded-lg mx-auto mt-4">
      <h1 className="text-2xl font-bold text-blue-800 mt-4">{t('accomplices')}</h1>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {scammedUsers.map((user, index) => (
          <div key={index} style={{ flex: '1 0 33%', boxSizing: 'border-box', padding: '10px' }}>
            <div style={{ border: '1px solid #ccc', padding: '10px', borderRadius: '5px' }}>
              <NameScammed user={user} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
